module.exports = __webpack_public_path__ + "img/thumbp2p3.e43d97f0.png";